import { render, staticRenderFns } from "./DoubleTextButton.vue?vue&type=template&id=09d44f4c&scoped=true&"
import script from "./DoubleTextButton.vue?vue&type=script&lang=js&"
export * from "./DoubleTextButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d44f4c",
  null
  
)

export default component.exports